// Funzione per decodificare testo offuscato con supporto UTF-8
export const decode = (encoded) => {
  try {
    // Decodifica base64 e gestisce correttamente UTF-8
    const binaryString = atob(encoded);
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    // Decodifica come UTF-8
    const decoded = new TextDecoder('utf-8').decode(bytes);
    return decoded.split('').reverse().join('');
  } catch (e) {
    // Fallback: prova con il metodo semplice
    try {
      const decoded = atob(encoded);
      return decoded.split('').reverse().join('');
    } catch (e2) {
      return '';
    }
  }
};

// Funzione helper per creare link offuscato
export const getObfuscatedLink = (text, url) => {
  const encodedText = btoa(text.split('').reverse().join(''));
  const encodedUrl = btoa(url.split('').reverse().join(''));
  return { encodedText, encodedUrl };
};

